/**
 * Rôles techniques (kind=2) portés par l'API dans le payload `/user/me`
 * (champ `roles`). Depuis le refactor du permission bundle, ces rôles ne sont
 * plus présents dans le JWT : la source de vérité est l'objet user renvoyé par
 * l'API, jamais le token décodé.
 */
export enum TechnicalRole {
  USER = 'ROLE_USER',
  CLIENT_ADMIN = 'ROLE_CLIENT_ADMIN',
  BO_ADMIN = 'ROLE_BO_ADMIN',
}
